<div class="company-top" hiddenInFrame>
	<div><company-contact [company]="company" /></div>
	<div class="shortcut-panel"><shortcut-panel [shortcuts]="shortcuts" /></div>
</div>
@if (showExtendedCompanyInformation && company.id) {
	<panel width="420">
		<menu always-visible>
			<menuitem (click)="newContact()" icon="user-plus">{{ 'contact.create-new' | translate }}</menuitem>
			<menuitem *requiredCredential="credentialType.UpdateCompanyFromCvr" (click)="editVatNumber()" icon="building">{{ 'company.edit-cvr.context-menu' | translate }}</menuitem>
		</menu>
		<h1>{{ 'company.contact-information' | translate }}</h1>
		<company-information [company]="company" />
		<list-contact [company]="company" />
	</panel>
}
